import { useCallback } from "react";

import SortIconAsc from "@/assets/icons/sort-icon-asc.svg";
import SortIconDesc from "@/assets/icons/sort-icon-desc.svg";
import { SORT_OPTIONS } from "@/constants/ui/workPlan";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { setMarketsSortOption } from "@/store/slices/ui";

import { SSGlobalStyle, StyledSSSortIcon, StyledSSSortWrapper } from "./Styled";

export const MarketSort = () => {
    const { marketsSortOption } = useAppSelector((state) => state.ui.workPlan);

    const dispatch = useAppDispatch();

    const handleChangeSortSelect = useCallback(
        (value: string) => {
            const selectedOption = SORT_OPTIONS.find(
                (option) => option.value === value,
            );
            if (selectedOption) {
                dispatch(setMarketsSortOption(selectedOption));
            }
        },
        [dispatch],
    );
    return (
        <>
            <SSGlobalStyle />
            <StyledSSSortWrapper
                onChange={handleChangeSortSelect}
                options={SORT_OPTIONS}
                placeholder="Оберіть сортування"
                value={marketsSortOption}
                virtual={false}
                classNames={{
                    popup: {
                        root: "markets-sort-popup",
                    },
                }}
                suffixIcon={
                    <StyledSSSortIcon
                        src={
                            marketsSortOption?.value?.includes("-desc")
                                ? SortIconDesc
                                : SortIconAsc
                        }
                        alt="sort-icon"
                    />
                }
            />
        </>
    );
};
